export const subscriptionFields = [
	{ icon: "envelope form-envelope", label: "Email address", name: "email" },
];
